import React, { useState } from 'react'


import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { postCompanyRules } from '../../../../MyApi/sb/companyrules'


import PageHeader from '../../../../Components/UI/PageHeader'
import AddCompanyRules from '../../../../Components/sb/companyRules/companyRulesStore/AddCompanyFields'



const CompanyRulesStore = () => {
const [sb_rule_id , setRuleId]= useState("")
const [sb_company_id, setCompanyId] =useState("")
const [duration ,setDuration]= useState("")
const [value ,setValue] = useState("")
const [active ,setActive]= useState(1)
const [process_type , setProcessType] =useState("")
const {i18n} = useTranslation()
const lang= i18n.language
 const mutation = useMutation(["postCompanyRules",lang ], (postData)=>postCompanyRules(postData,lang ) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setDuration("")
        setValue("")
        setProcessType("")
       
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        sb_rule_id,
        sb_company_id,
        duration,
        value,
        active,
        process_type

    })
 }
 const isDisabled= ()=>{
     return !(sb_rule_id &&sb_company_id &&duration && value )

 }
  return ( 

    <div>
        <PageHeader title="Add Company Rules" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddCompanyRules setCompanyId={setCompanyId} setProcessType={setProcessType} duration={duration} value={value} setDuration={setDuration} setRuleId={setRuleId} setActive={setActive} active={active}  setValue={setValue} process_type={process_type}/>
    </div>
  )
}

export default CompanyRulesStore